/**
 * Personalisierung der Anwendung (Änderungsanforderung ÄA-5).
 *
 * §40.4 schließt eine „Brandingverwaltung im Backend" aus. Der Auftraggeber verlangt sie
 * gleichwohl: Fußzeilenverweis, Impressum, Datenschutz und ein eigenes Firmenlogo je Installation.
 * Die Abweichung ist als ÄA-5 in `docs/AENDERUNGSANFORDERUNGEN.md` dokumentiert und freigegeben.
 *
 * Dieses Modul enthält ausschließlich Pfade, Grenzen und Typen (§41.2). Impressum und
 * Datenschutzerklärung sind **Markdown**; ihre Zerlegung und Kanonisierung liegt in `richtext.ts`
 * und wird serverseitig durchgesetzt (§25.2).
 */
export const PERSONALISIERUNG_ADMIN_PATH = '/api/v1/admin/personalisierung';
export const PERSONALISIERUNG_PUBLIC_PATH = '/api/v1/public/personalisierung';
/** Die beiden Erscheinungsbilder nach §21 — je Erscheinungsbild ein eigenes Logo. */
export const LOGO_VARIANTEN = ['hell', 'dunkel'];
export function istLogoVariante(wert) {
    return typeof wert === 'string' && LOGO_VARIANTEN.includes(wert);
}
/**
 * Adresse eines hinterlegten Logos.
 *
 * Der Stand hängt als Abfrageteil an: Das Bild darf lange zwischengespeichert werden, ein neu
 * hochgeladenes muss aber sofort erscheinen. Ohne den Wert zeigte der Browser nach dem Wechsel
 * weiter das alte Logo.
 */
export function personalisierungLogoPfad(variante, stand) {
    return `${PERSONALISIERUNG_PUBLIC_PATH}/logo/${variante}?v=${encodeURIComponent(stand)}`;
}
/** Feldgrenzen. Serverseitig verbindlich, im Formular nur als Bedienhilfe. */
export const PERSONALISIERUNG_GRENZEN = {
    feedbackUrl: 500,
    impressum: 50_000,
    datenschutz: 50_000,
};
/**
 * Grenzen für den Logo-Upload.
 *
 * 512 KB ist reichlich für ein Logo und klein genug, dass die Datenbank nicht anschwillt — sie
 * liegt vollständig in jedem Backup (§28.1). SVG ist zugelassen, weil Logos meist so vorliegen;
 * es wird ausschließlich als `<img src>` eingebunden, und dort führt kein Browser ein Skript aus.
 */
export const LOGO_GRENZEN = {
    maxBytes: 512 * 1024,
    typen: ['image/png', 'image/webp', 'image/jpeg', 'image/svg+xml'],
};
//# sourceMappingURL=personalisierung.js.map